import React from 'react';
import { RefreshCwIcon, SearchIcon, XIcon } from 'lucide-react';
import { FILE_TYPE_META, FILE_TYPE_ORDER } from '../../utils/fileTypes';
import type { FileType } from '../../types/files';
interface FilesToolbarProps {
  query: string;
  onQueryChange: (value: string) => void;
  activeTypes: FileType[];
  typeCounts: Map<FileType, number>;
  onToggleType: (type: FileType) => void;
  onClearFilters: () => void;
  onRefresh: () => void;
  isBusy: boolean;
}
export function FilesToolbar({
  query,
  onQueryChange,
  activeTypes,
  typeCounts,
  onToggleType,
  onClearFilters,
  onRefresh,
  isBusy
}: FilesToolbarProps) {
  const hasFilters = activeTypes.length > 0 || query.trim().length > 0;
  return <div className="border-b border-slate-200 bg-slate-50/70 px-4 py-3" data-id="element-120" data-mp="3bthauqb97w9n">
      <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between" data-id="element-121" data-mp="2wvf3e513qqn4">
        <div className="flex flex-wrap items-center gap-1.5" role="group" aria-label="Filter by file type" data-id="element-122" data-mp="31tyv6m2dmwne">
          {FILE_TYPE_ORDER.map(type => {
          const count = typeCounts.get(type) ?? 0;
          const meta = FILE_TYPE_META[type];
          const isActive = activeTypes.includes(type);
          const Icon = meta.icon;
          return <button key={type} type="button" aria-pressed={isActive} disabled={count === 0} onClick={() => onToggleType(type)} className={['inline-flex items-center gap-1.5 rounded border px-2 py-1 text-xs font-semibold transition focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0176d3] focus-visible:ring-offset-1', count === 0 ? 'cursor-not-allowed border-slate-200 bg-white text-slate-300' : isActive ? meta.activeChipClass : 'border-slate-300 bg-white text-slate-700 hover:border-slate-400 hover:bg-slate-100'].join(' ')} data-id="element-123" data-mp="34ziox1rh529a">
                <Icon className={['h-3.5 w-3.5', count === 0 ? 'text-slate-300' : meta.iconClass].join(' ')} aria-hidden="true" data-id="element-124" data-mp="1j2g9j5uxkv8" />
                {meta.label}
                <span className="tabular-nums font-normal opacity-70" data-id="element-125" data-mp="bb88mu00u4ay">
                  {count}
                </span>
              </button>;
        })}
          {hasFilters && <button type="button" onClick={onClearFilters} className="inline-flex items-center gap-1 rounded px-2 py-1 text-xs font-medium text-[#0176d3] hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0176d3]" data-id="element-126" data-mp="3eryijjyq51hx">
              <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-127" data-mp="z0u2d1xmjrbk" />
              Clear
            </button>}
        </div>

        <div className="flex items-center gap-2" data-id="element-128" data-mp="2ofllclzolk66">
          <div className="relative w-full lg:w-64" data-id="element-129" data-mp="2ofbrgnbimsv7">
            <SearchIcon className="pointer-events-none absolute left-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" aria-hidden="true" data-id="element-130" data-mp="2jg8or9j0cyqe" />
            <input type="search" value={query} onChange={event => onQueryChange(event.target.value)} placeholder="Search files" aria-label="Search files" className="w-full rounded border border-slate-300 bg-white py-1.5 pl-8 pr-3 text-sm text-slate-900 placeholder:text-slate-400 focus:border-[#0176d3] focus:outline-none focus:ring-1 focus:ring-[#0176d3]" data-id="element-131" data-mp="29qyv3p8in806" />
          </div>
          <button type="button" onClick={onRefresh} aria-label="Refresh file list" className="inline-flex h-8 w-8 items-center justify-center rounded border border-slate-300 bg-white text-slate-600 transition hover:bg-slate-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0176d3] focus-visible:ring-offset-1" data-id="element-132" data-mp="1qtxro8um1fyc">
            <RefreshCwIcon className={['h-4 w-4', isBusy ? 'animate-spin' : ''].join(' ')} aria-hidden="true" data-id="element-133" data-mp="2mtrr15p4caia" />
          </button>
        </div>
      </div>
    </div>;
}